import React, { useState } from 'react';
import './App.css';

const members = [
  {
    name: "ふ〜ま",
    fullName: "中津井楓真",
    tags: ["#バスケットボール", "#英語", "#野球", "#古着", "#探求学習", "#コンビニスイーツ", "#漫画"],
    img: "./img/ふ〜ま/ふ〜ま01.jpg",
    link: "fuma.html",
  },
  {
    name: "ノア",
    fullName: "ラッドキ岸本音阿",
    tags: ["#生物学", "#医学", "#英語", "#研究", "#プログラミング", "#建築", "#テニス", "#バスケットボール", "#バレーボール", "#ドラマ鑑賞", "#コーヒー"],
    img: "./img/ノア/ノア01.JPG",
    link: "noah.html",
  },
  {
    name: "さら",
    fullName: "井上桜来",
    tags: ["#洋楽", "#英語", "#新しいこと", "#コーヒー", "#子ども", "#読書"],
    img: "./img/さら/さら01.jpg",
    link: "sara.html",
  },
];

const tags = [
  "#バスケットボール", "#野球", "#テニス", "#バレーボール",
  "#英語", "#生物学", "#医学", "#研究", "#プログラミング", "#建築",
  "#古着", "#コンビニスイーツ", "#漫画", "#洋楽", "#ドラマ鑑賞", "#コーヒー",
];

function App() {
  const [selectedTags, setSelectedTags] = useState([]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedTags(prevTags =>
      checked ? [...prevTags, value] : prevTags.filter(tag => tag !== value)
    );
  };

  const filteredMembers = members.filter(member =>
    selectedTags.every(tag => member.tags.includes(tag))
  );

  return (
    <div>
      <h2>ハッシュタグで検索</h2>
      <div className="search-filters">
        {tags.map((tag, index) => {
          const isChecked = selectedTags.includes(tag);
          return (
            <label
              key={index}
              className={isChecked ? 'selected' : ''}
            >
              <input
                type="checkbox"
                value={tag}
                onChange={handleCheckboxChange}
                checked={isChecked}
              />
              {tag}
            </label>
          );
        })}
      </div>

      <div className="search-results">
  {filteredMembers.map((member, index) => (
    <div key={index} className="member">
      <img
        src={`${process.env.PUBLIC_URL}/${member.img}`} // Dynamically using member.img
        alt={member.name}
        className="member-image"
      />
      <div className="member-info">
        <h3>{member.name} <span>/ {member.fullName}</span></h3>
        <div className="tags">
          {member.tags.map((tag, idx) => (
            <span key={idx} className="tag">{tag}</span>
          ))}
        </div>
        <a href={member.link} className="details-button">詳しく見る</a>
      </div>
    </div>
  ))}
</div>

    </div>
  );
}

export default App;
